import React, { useState } from 'react';

const SalesFilterSelectBox = ({ onFilterChange }) => {
    // 임원진 보고 및 화면 검증용 예비 조직도 데이터
    const [selectedDept, setSelectedDept] = useState('ALL');
    const [selectedMember, setSelectedCompanyMember] = useState('ALL');

    const deptOptions = [
        { value: 'ALL', label: '전체 부서' },
        { value: 'DEPT01', label: '영업 1본부 (공공/금융)' },
        { value: 'DEPT02', label: '영업 2본부 (제조/엔터프라이즈)' },
        { value: 'DEPT03', label: '클라우드 사업팀' },
        { value: 'DEPT04', label: '글로벌 비즈니스팀' },
    ];

    const memberOptions = {
        ALL: [{ value: 'ALL', label: '전체 담당자' }],
        DEPT01: [
            { value: 'ALL', label: '전체 담당자' },
            { value: 'M01', label: '홍길동 팀장' },
            { value: 'M02', label: '유관순 대리' },
        ],
        DEPT02: [
            { value: 'ALL', label: '전체 담당자' },
            { value: 'M03', label: '강감찬 차장' },
            { value: 'M04', label: '이순신 과장' },
        ],
        DEPT03: [
            { value: 'ALL', label: '전체 담당자' },
            { value: 'M05', label: '김유신 팀장' },
        ],
        DEPT04: [
            { value: 'ALL', label: '전체 담당자' },
            { value: 'M06', label: '스미스 파트장' },
        ],
    };

    const handleDeptChange = (e) => {
        const dept = e.target.value;
        setSelectedDept(dept);
        setSelectedCompanyMember('ALL'); 
        
        if (onFilterChange) {
            onFilterChange({ dept, member: 'ALL' });
        }
    };

    const handleMemberChange = (e) => {
        const member = e.target.value;
        setSelectedCompanyMember(member);
        
        if (onFilterChange) {
            onFilterChange({ dept: selectedDept, member });
        }
    };

    const selectStyle = {
        padding: '6px 32px 6px 16px', /* 💡 선택 상자 자체의 높이도 살짝 줄여서 컴팩트하게 매칭 */
        fontSize: '13px',
        fontWeight: '600',
        color: '#334155',
        backgroundColor: '#ffffff',
        border: '1px solid #E2E8F0',
        borderRadius: '8px',
        cursor: 'pointer',
        outline: 'none',
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
        appearance: 'none', 
        backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://w3.org' viewBox='0 0 24 24' fill='none' stroke='%2364748B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 12px center',
        backgroundSize: '14px',
        minWidth: '160px',
        transition: 'all 0.15s ease'
    };

    return (
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px',
            background: '#F8FAFC',
            padding: '6px 20px', /* 💡 상하 내부 여백을 12px에서 6px로 축소 */
            borderRadius: '12px',
            border: '1px solid #E2E8F0',
            boxSizing: 'border-box',
            marginBottom: '12px', /* 💡 아래 차트 영역과의 간격을 20px에서 12px로 축소 */
            width: '100%'
        }}>
            {/* 필터링 인디케이터 배지 */}
            <div style={{ 
                fontSize: '12px', 
                fontWeight: '700', 
                color: '#1E3A8A', 
                backgroundColor: '#EFF6FF', 
                padding: '3px 10px', 
                borderRadius: '6px',
                letterSpacing: '-0.3px',
                flexShrink: 0
            }}>
                조회 조건 필터
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '8px' }}>
                <label style={{ fontSize: '12px', fontWeight: '700', color: '#64748B' }}>소속 부서</label>
                <select 
                    value={selectedDept} 
                    onChange={handleDeptChange}
                    style={selectStyle}
                    onMouseOver={(e) => e.currentTarget.style.borderColor = '#CBD5E1'}
                    onMouseOut={(e) => e.currentTarget.style.borderColor = '#E2E8F0'}
                >
                    {deptOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <label style={{ fontSize: '12px', fontWeight: '700', color: '#64748B' }}>담당자</label>
                <select 
                    value={selectedMember} 
                    onChange={handleMemberChange}
                    style={selectStyle}
                    onMouseOver={(e) => e.currentTarget.style.borderColor = '#CBD5E1'}
                    onMouseOut={(e) => e.currentTarget.style.borderColor = '#E2E8F0'}
                >
                    {(memberOptions[selectedDept] || memberOptions.ALL).map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default SalesFilterSelectBox;
